import React from 'react'

const BreadCrumb = (props: any) => {
    return (
        <>
            {
                props?.parentDeps ? <>
                    {
                        props?.parentDeps.map((dep: any, index: number) => {
                            return (<><a className="breadc-list" key={`dds-${dep.departmentID}`} href={dep.searchUrl}>{dep.name}</a> <> {'>'} </> </>)
                        })
                    }
                </> : ''

            }
            {
                props?.name && props.name != '' ? <>
                    <span className="bold-text">{props.name}</span>
                </> : ''

            }
        </>
    )
}
export default BreadCrumb;
